import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '@/common/SafeIcon';

const { FiCloud, FiMapPin, FiPhone, FiMail } = FiIcons;

const Footer = () => {
  return (
    <footer className="bg-slate-900 text-slate-300 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <SafeIcon icon={FiCloud} className="h-6 w-6 text-sky-400" />
              <span className="font-bold text-lg text-white">Cloud's Boarding House</span>
            </div>
            <p className="text-sm text-slate-400">
              Providing affordable, safe, and comfortable monthly bed-space accommodation for students and young professionals.
            </p>
          </div>
          
          <div>
            <h3 className="text-white font-semibold mb-4">Contact Information</h3>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-2">
                <SafeIcon icon={FiMapPin} className="h-5 w-5 text-sky-400 shrink-0" />
                <span>Mira Monte Subdivision, Lucban,<br/>Quezon 4328, Philippines</span>
              </li>
              <li className="flex items-center gap-2">
                <SafeIcon icon={FiPhone} className="h-4 w-4 text-sky-400" />
                <span>(042) 123-4567</span>
              </li>
              <li className="flex items-center gap-2">
                <SafeIcon icon={FiMail} className="h-4 w-4 text-sky-400" />
                <span>hello@cloudsboardinghouse.com</span>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2 text-sm">
              <li><a href="#/" className="hover:text-sky-400 transition-colors">Home</a></li>
              <li><a href="#/accommodation" className="hover:text-sky-400 transition-colors">View Accommodation</a></li>
              <li><a href="#/contact" className="hover:text-sky-400 transition-colors">Contact Us</a></li>
              <li><a href="#/admin" className="hover:text-sky-400 transition-colors">Admin Portal</a></li>
            </ul>
          </div>
        </div>
        <div className="border-t border-slate-800 mt-12 pt-8 text-sm text-center text-slate-500">
          &copy; {new Date().getFullYear()} Cloud's Boarding House. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;